/**
 * NonExecGuard
 * V202: role_exec 임원 접근 차단 가드
 *
 * role_exec 역할을 가진 사용자가 특정 경로에 접근하는 것을 차단합니다.
 * 주로 "내 인사기록" 등 개인 기록 열람 페이지에서 사용됩니다.
 *
 * **차단 대상:**
 * - auth_roleAssignments에서 roleId === 'role_exec'인 사용자
 *
 * **사용 방법:**
 * <Route
 *   path="my/interviews"
 *   element={
 *     <NonExecGuard>
 *       <MyInterviewsPage />
 *     </NonExecGuard>
 *   }
 * />
 */

import React from 'react';
import { useAuthContext } from '../shared/hooks/useAuthContext';
import { hasRole } from '../utils/rbac';

interface NonExecGuardProps {
  children: React.ReactElement;
}

export function NonExecGuard({ children }: NonExecGuardProps) {
  const authContext = useAuthContext();

  // 인증 정보 로딩 중
  if (!authContext.isLoaded) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        color: 'var(--color-gray-500)',
      }}>
        권한 확인 중...
      </div>
    );
  }

  // role_exec 여부 확인
  const isRoleExec = hasRole(authContext, 'role_exec');

  // role_exec인 경우 차단
  if (isRoleExec) {
    console.warn('[NonExecGuard] V202: role_exec 접근 차단');

    return (
      <div style={{
        padding: '40px',
        textAlign: 'center',
      }}>
        <h2 style={{
          fontSize: '18px',
          fontWeight: '500',
          color: 'var(--color-gray-700)',
          marginBottom: '16px',
        }}>
          접근 권한이 없습니다
        </h2>
        <div style={{ marginTop: '24px' }}>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '8px 24px',
              background: 'var(--color-primary)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            뒤로 가기
          </button>
        </div>
      </div>
    );
  }

  // 접근 허용
  return children;
}
